import { browser } from '$app/environment';
import { PUBLIC_CDS_ENDPOINT, PUBLIC_UNIFIED_ENDPOINT } from '$env/static/public';

const isDevelopment = import.meta.env.MODE === 'development';
const shouldUseProxy = browser && isDevelopment;

export const UNIFIED_API_BASE_URL = shouldUseProxy ? '/PROXY_UNIFIED' : PUBLIC_UNIFIED_ENDPOINT;
export const CDS_API_BASE_URL = shouldUseProxy ? '/PROXY_CDS' : PUBLIC_CDS_ENDPOINT;
